// S4 One app's queue (root 6.6, REQ-8.1, REQ-8.2, REQ-8.4). The page is the shared QueueView;
// All tickets (/queue, CT-001) is the same page across every app the person can see.
import { createFileRoute } from '@tanstack/react-router';
import { QueueView } from '@/features/tickets/QueueView';
import { parseQueueSearch, type QueueSearch } from '@/features/tickets/queue-search';
import { requireStaffSession } from '@/lib/session';

export const Route = createFileRoute('/apps/$appId/queue')({
  // No App filter on one app's queue: the key stays, undefined, so a raw `?app=` can't survive (queue-search.ts).
  validateSearch: (search: Record<string, unknown>): QueueSearch => ({ ...parseQueueSearch(search), app: undefined }),
  beforeLoad: ({ context, location }) => requireStaffSession(context.queryClient, location.href),
  component: AppQueuePage,
});

function AppQueuePage() {
  const { appId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <QueueView
      appId={appId}
      search={search}
      setSearch={(patch) =>
        navigate({ search: (prev: QueueSearch) => ({ ...prev, ...patch, page: undefined }), replace: true })
      }
      onPageChange={(page) => navigate({ search: (prev: QueueSearch) => ({ ...prev, page }) })}
    />
  );
}
